import { render, staticRenderFns } from "./ExpertStatus.vue?vue&type=template&id=472f021f&scoped=true"
import script from "./ExpertStatus.vue?vue&type=script&lang=js"
export * from "./ExpertStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472f021f",
  null
  
)

export default component.exports